import React from 'react';
import { Formik, Form } from 'formik';
import { Button } from '../Button/Button';
import { FormFields } from './FormFields';
import { AddUserFormValues, validationSchema, defaultValues } from './types';
import { useAddUserForm } from './hooks/useAddUserForm';
import './UserForm.scss';

interface AddUserFormProps {
  onSubmit: (values: AddUserFormValues) => void;
  onCancel: () => void;
}

export const AddUserForm: React.FC<AddUserFormProps> = ({ onSubmit, onCancel }) => {
  const { handleSubmit } = useAddUserForm({ onSubmit, onCancel });

  return (
    <div className="user-form">
      <h2>Add New User</h2>
      <Formik
        initialValues={defaultValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnMount={true}
        validateOnBlur={true}
        validateOnChange={true}
      >
        {(formik) => (
          <Form
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              formik.setTouched({
                firstName: true,
                lastName: true,
                email: true,
                phone: true,
                agency: true,
                role: true,
                accessTo: true,
                office: true,
              });
              formik.handleSubmit(e);
            }}
          >
            <FormFields formik={formik} userDetails={null} />
            <div className="form-actions">
              <Button variant="button" className="outline cancel" type="button" onClick={onCancel}>
                Cancel
              </Button>
              <Button variant="button" type="submit">
                Add New User
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
